// 系统管理路由
export default {
    path: 'system',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '系统管理'},
    children: [
        {
            path: 'adminUser',
            component: () => import('@/components/RouterView'),
            redirect: '/system/adminUser/list',
            meta: {title: '员工管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/system/adminUser/list.vue'),
                    meta: {title: '员工列表'}
                },
                {
                    path: 'loginRecord',
                    component: () => import('@/views/system/adminUser/loginRecord.vue'),
                    meta: {title: '员工行为日志'}
                }
            ]
        },
		{
		    path: 'ticketSeatNumber',
		    component: () => import('@/components/RouterView'),
		    redirect: '/system/ticketSeatNumber/list',
		    meta: {title: '座位号字段配置'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/system/ticketSeatNumber/list.vue'),
		            meta: {title: '座位号字段配置列表'}
		        },
		        // {
		        //     path: 'loginRecord',
		        //     component: () => import('@/views/system/adminUser/loginRecord.vue'),
		        //     meta: {title: '员工行为日志'}
		        // }
		    ]
		},
        {
            path: 'privilege',
            component: () => import('@/components/RouterView'),
            redirect: '/system/privilege/list',
            meta: {title: '后台权限管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/system/privilege/ht/list.vue'),
                    meta: {title: '后台权限列表'}
                }
            ]
        },
        {
            path: 'role',
            component: () => import('@/components/RouterView'),
            redirect: '/system/role/list',
            meta: {title: '后台角色管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/system/role/ht/list.vue'),
                    meta: {title: '后台角色列表'}
                },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/system/role/ht/edit.vue'),
                    meta: {title: '编辑后台角色'},
                    props: true
                },
                {
                    path: 'add',
                    component: () => import('@/views/system/role/ht/edit.vue'),
                    meta: {title: '创建后台角色'}
                }
            ]
        },
        {
            path: 'serviceTemplate',
            component: () => import('@/components/RouterView'),
            redirect: '/system/serviceTemplate/list',
            meta: {title: '服务模板'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/system/serviceTemplate/activitylist.vue'),
                    meta: {title: '演出模板列表'}
                },
				{
				    path: 'goodslist',
				    component: () => import('@/views/system/serviceTemplate/goodslist.vue'),
				    meta: {title: '周边模板列表'}
				},
				{
				    path: 'otherlist',
				    component: () => import('@/views/system/serviceTemplate/otherlist.vue'),
				    meta: {title: '其他模板列表'}
				},
                {
                    path: 'edit/:id/:type/:minitype',
                    component: () => import('@/views/system/serviceTemplate/edit.vue'),
                    meta: {title: '编辑服务模板'},
                    props: true
                },
                {
                    path: 'add/:type/:minitype',
                    component: () => import('@/views/system/serviceTemplate/edit.vue'),
                    meta: {title: '新建服务模板'},
					props: true
                }
            ]
        },
        {
            path: 'whiteList',
            component: () => import('@/views/system/whiteList/index.vue'),
            meta: {title: '白名单'}
        },
		{
			path: 'consign',
			component: () => import('@/views/system/consign'),
			meta: {title: '托售管理'},
		},
        {
            path: 'imgDepot',
            component: () => import('@/views/system/imgDepot/components/ImgDepotTab'),
            redirect: '/system/imgDepot/background',
            meta: {title: '图库管理'},
            children: [
                {
                    path: 'background',
                    name: 'imgDepot-background',
                    component: () => import('@/views/system/imgDepot/list.vue'),
                    meta: {title: '图库管理'}
                },
                {
                    path: 'list',
                    name: 'imgDepot-system',
                    component: () => import('@/views/system/imgDepot/list.vue'),
                    meta: {title: '图库管理'}
                }
            ]
        },
        {
            path: 'exchangeRate',
            component: () => import('@/views/system/exchangeRate/index.vue'),
            meta: {title: '汇率管理'}
        },
        {
            path: 'musicStyleLabel',
            component: () => import('@/views/system/systemOption/musicStyleLabel/index.vue'),
            meta: {title: '音乐风格'}
        },
		{
		    path: 'styleLabel',
		    component: () => import('@/views/system/systemOption/styleLabel/index.vue'),
		    meta: {title: '活动类型',activePage: '/system/musicStyleLabel'}
		},
        {
		    path: 'siteLabel',
		    component: () => import('@/views/system/systemOption/siteLabel/index.vue'),
		    meta: {title: '场地类型',activePage: '/system/siteLabel'}
		},
		{
		    path: 'goodsLabel',
		    component: () => import('@/views/system/systemOption/goodsLabel/index.vue'),
		    meta: {title: '周边选项配置',activePage: '/system/goodsLabel'}
		},
        {
            path: 'certification',
            component: () => import('@/views/system/certification/index.vue'),
            meta: {title: '实名认证规则'}
        },
        {
            path: 'fb/role',
            component: () => import('@/components/RouterView'),
            redirect: '/system/fb/role/list',
            meta: {title: '经营平台角色管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/system/role/fb/list.vue'),
                    meta: {title: '经营平台角色列表', activePage: '/system/role/list'}
                },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/system/role/fb/edit.vue'),
                    meta: {title: '编辑经营平台角色', activePage: '/system/role/list'},
                    props: true
                },
                {
                    path: 'add',
                    component: () => import('@/views/system/role/fb/edit.vue'),
                    meta: {title: '创建经营平台角色', activePage: '/system/role/list'}
                }
            ]
        },
        {
            path: 'fb/privilege',
            component: () => import('@/components/RouterView'),
            redirect: '/system/fb/privilege/list',
            meta: {title: '经营平台权限管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/system/privilege/fb/list.vue'),
                    meta: {title: '经营平台权限列表',activePage: '/system/privilege/list'}
                }
            ]
        },
        {
            path: 'thirdAccountManage',
            component: () => import('@/components/RouterView'),
            redirect: '/system/thirdAccountManage/list',
            meta: {title: '演出外部销售渠道配置功能'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/system/thirdAccountManage/list.vue'),
                    meta: {title: '配置列表列表'}
                }
            ]
        },
        {
            path: 'verificationSwitch',
            component: () => import('@/views/system/verificationSwitch'),
            meta: {title: '三方验证码设置'},
        },
        {
            path: 'userLabel',
            component: () => import('@/views/system/userLabel'),
            meta: {title: '用户属性标签'},
        },
        {
            path: 'shortUrl',
            component: () => import('@/views/sysTool/shortUrl/index.vue'),
            redirect: '/sysTool/shortUrl',
            meta: {title: '短链接配置'}
        },
		{
		    path: 'hotWords',
		    component: () => import('@/views/system/hotWords'),
		    meta: {title: '搜索管理'},
		},		
		{
		    path: 'homepageSort',
		    component: () => import('@/views/system/homepageSort'),
		    meta: {title: '首页列表排序权重'},
		},
		//内容渠道管理
		{
		    path: 'channel',
		    component: () => import('@/components/RouterView'),
		    redirect: '/system/channel/index',
		    meta: { title: '内容渠道管理'},
		    children: [
		        {
		            path: '',
		            component: () => import('@/views/system/channel/index.vue'),
		            meta: {title: '内容渠道管理列表'}
		        },
				{
				    path: 'add',
				    component: () => import('@/views/system/channel/edit.vue'),
				    meta: {title: '新建内容渠道', activePage: '/system/channel'}
				},
				{
				    path: 'edit/:id',
				    component: () => import('@/views/system/channel/edit.vue'),
				    meta: {title: '内容渠道管理编辑', activePage: '/system/channel'},
				    props: true
				}
		    ]
		},
    ]
};
